function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2C14.8929 2 17.2381 4.29064 17.2381 7.11628C17.2381 8.67998 16.5199 10.0798 15.3881 11.0183L17.3014 15.0233H21.0476C21.5736 15.0233 22 15.4397 22 15.9535V21.0698C22 21.5835 21.5736 22 21.0476 22H2.95238C2.4264 22 2 21.5835 2 21.0698V15.9535C2 15.4397 2.4264 15.0233 2.95238 15.0233H6.6981L8.61189 11.0183C7.48011 10.0798 6.7619 8.67998 6.7619 7.11628C6.7619 4.29064 9.10708 2 12 2ZM20.0952 16.8837H3.90476V20.1395H20.0952V16.8837ZM12 3.86047C10.1591 3.86047 8.66667 5.31814 8.66667 7.11628C8.66667 8.0424 9.06259 8.90186 9.74517 9.51422L9.84461 9.6C10.4989 10.1425 10.7009 11.0454 10.338 11.8051L8.80037 15.0233H15.1996L13.662 11.8051C13.3136 11.0758 13.4859 10.2145 14.0791 9.6668L14.1554 9.6C14.8988 8.98356 15.3333 8.0865 15.3333 7.11628C15.3333 5.31814 13.8409 3.86047 12 3.86047Z"
});

function SvgIconWatermask(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWatermask);
export default __webpack_public_path__ + "static/media/icon_watermask.801d1836.svg";
export { ForwardRef as ReactComponent };